import axios from 'axios';

const defaultHeaders = {
  'Content-Type': 'application/json',
   'Accept': '*',
};

export const httpGet = (url, headers = defaultHeaders) => {
  return new Promise((resolve, reject) => {
    axios({ method: 'GET', url: url, headers })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const httpPut = (url, reqBody, headers = defaultHeaders) => {
  return new Promise((resolve, reject) => {
    axios({ method: 'PUT', url: url, data: reqBody, headers: headers })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const httpPatch = (url, reqBody, headers = defaultHeaders) => {
  return new Promise((resolve, reject) => {
    axios({ method: 'PATCH', url: url, data: reqBody, headers: headers })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const httpPost = (url, reqBody, headers = defaultHeaders) => {
  return new Promise((resolve, reject) => {
    axios({ method: 'POST', url: url, data: reqBody, headers: headers })
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};
